<template>
  <div class="columns is-marginless main">
    <div class="column is-narrow has-background-white-bis sidebar">
      <div class="field">
        <label class="label">Search for</label>
        <div class="select">
          <select v-model="selectedSearchModeId">
            <option v-for="searchMode in searchModes" :key="searchMode.id" :value="searchMode.id">{{
              searchMode.name
            }}</option>
          </select>
        </div>
      </div>

      <!-- Search form -->
      <form @submit.prevent="triggerSearch">
        <div class="field">
          <div class="control has-icons-left">
            <input
              class="input"
              type="text"
              :placeholder="searchFieldPlaceholder"
              v-model="searchInput"
            />
            <span class="icon is-small is-left">
              <i class="icon-search"></i>
            </span>
          </div>
        </div>
      </form>

      <RouterView name="master" :key="$route.fullPath" />
    </div>

    <div class="column details">
      <RouterView name="details" :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  components: {},

  data() {
    return {
      searchModes: [
        {
          id: 'users',
          name: 'Users',
          searchFieldPlaceholder: 'Id, Email, Phone (only numbers) or Name',
          routerName: 'usersSearch',
          matchesRoute: route => {
            return route.path.startsWith('/search/users')
          }
        },
        {
          id: 'gpsDevices',
          name: 'GPS',
          searchFieldPlaceholder: 'IMEI',
          routerName: 'gpsDevicesSearch',
          matchesRoute: route => {
            return (
              route.path.startsWith('/search/gps') || route.path.startsWith('/search/wehuntgps')
            )
          }
        },
        {
          id: 'huntAreas',
          name: 'Hunt Areas',
          searchFieldPlaceholder: 'Id, Name (must match complete name)',
          routerName: 'huntAreasSearch',
          matchesRoute: route => {
            return route.path.startsWith('/search/huntareas')
          }
        },
        {
          id: 'gamecams',
          name: 'Gamecams',
          searchFieldPlaceholder: 'Email (part before @)',
          routerName: 'gamecamsSearch',
          matchesRoute: route => {
            return route.path.startsWith('/search/gamecams')
          }
        }
      ],
      selectedSearchModeId: 'users',

      searchInput: ''
    }
  },

  methods: {
    triggerSearch() {
      if (!this.searchInput) {
        return
      }

      this.$router.push({
        name: this.selectedSearchMode.routerName,
        query: { q: this.searchInput }
      })
    }
  },

  computed: {
    selectedSearchMode() {
      return this.searchModes.find(searchMode => searchMode.id === this.selectedSearchModeId)
    },

    searchFieldPlaceholder() {
      const selectedSearchMode = this.selectedSearchMode
      if (selectedSearchMode) {
        return selectedSearchMode.searchFieldPlaceholder
      }

      return ''
    }
  },

  created() {},

  mounted() {
    // Make sure correct search mode is selected based on current route
    const matchingSearchMode = this.searchModes.filter(searchMode =>
      searchMode.matchesRoute(this.$route)
    )
    if (matchingSearchMode.length > 0) {
      this.selectedSearchModeId = matchingSearchMode[0].id
    } else {
      this.selectedSearchModeId = this.searchModes[0].id
    }

    this.searchInput = this.$route.query.q
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.main {
  height: 100%;
}

.details {
  overflow: hidden;
}

.main .sidebar {
  min-width: 24rem;
  border-right-color: $grey-lightest;
  border-right-style: solid;
  border-right-width: 1px;
  overflow-y: scroll;
}

.select {
  width: 100%;
}

select {
  width: 100%;
}

form {
  padding-bottom: $column-gap;
}
</style>
